import Seo from "@/components/Seo";
import { PageHero, Btn, DevisCta } from "@/components/Shared";

const TIMELINE = [
  {
    periode: "1987 – 1989",
    titre: "CAP cuisine, mention pâtisserie",
    texte: "Formation initiale en cuisine, diplômé en 1989 avec la mention pâtisserie.",
  },
  {
    periode: "1990 – 1991",
    titre: "Service national — France puis Liban",
    texte: "Service national effectué en France puis au Liban.",
  },
  {
    periode: "1991 – 2003",
    titre: "Chef puis directeur de restauration à thème",
    texte: "Douze années en cuisine puis en direction d’établissements de restauration à thème.",
  },
  {
    periode: "2004 – 2007",
    titre: "Chef des cuisines",
    texte: "Chef des cuisines, en collaboration avec le chef Michel Sarran.",
  },
  {
    periode: "2007 – 2019",
    titre: "Directeur restauration multisites & consultant qualité",
    texte: "Direction d’unités de restauration multisites et missions de conseil en qualité.",
  },
  {
    periode: "2014 – 2016",
    titre: "Master 2 hôtellerie-restauration (niveau 7)",
    texte: "Reprise d’études parallèlement à l’activité : Master 2 en hôtellerie-restauration.",
  },
  {
    periode: "Depuis 2024",
    titre: "IA & no-code",
    texte: "Formation et pratique de l’IA et du no-code : Alegria Academy, SLN Skool, L’IA Café.",
  },
  {
    periode: "2025",
    titre: "Titre FPA — Formateur Professionnel d’Adultes",
    texte:
      "Certification de formateur professionnel d’adultes. Formateur en CFA (cuisine, pâtisserie, bac pro, RPMS) et jury d’examen.",
  },
  {
    periode: "2025 – 2026",
    titre: "Auteur & créateur d’applications SaaS",
    texte:
      "Publication de la collection « Le Monde en fiches » et création d’applications SaaS, dont Tablecho pour la restauration.",
  },
];

export default function QuiSuisJe() {
  return (
    <div data-testid="page-qui-suis-je">
      <Seo
        title="Qui suis-je — François Schoonheere, formateur certifié — Form Action Pro"
        description="François Schoonheere : 35 ans de restauration, du CAP cuisine au Master 2, formateur professionnel d'adultes certifié, consultant auditeur, auteur. Parcours 1987-2026."
        path="/qui-suis-je"
      />
      <PageHero
        kicker="Qui suis-je"
        title="François Schoonheere"
        subtitle="Formateur professionnel d’adultes certifié, consultant auditeur en restauration, auteur. Un parcours entièrement construit sur le terrain, de la cuisine à la formation."
      />

      <section className="bg-sable py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="grid lg:grid-cols-[1fr_320px] gap-12 items-start">
            <div className="space-y-5 font-sans text-base text-marine/80 leading-[1.7]">
              <p>
                Je n’enseigne rien que je n’aie pratiqué. Cuisinier, chef, directeur de
                restauration, consultant qualité : j’ai passé trente-cinq ans dans le métier avant
                d’en former les équipes.
              </p>
              <p>
                Depuis 2024, j’ai ajouté une corde à cet arc : l’IA et le no-code, appris auprès
                d’Alegria Academy, SLN Skool et L’IA Café, et mis au service des structures que
                j’accompagne.
              </p>
              <p>
                Aujourd’hui, je forme en CFA — cuisine, pâtisserie, bac pro, RPMS — je siège comme
                jury d’examen, et j’accompagne les professionnels sur l’IA, l’automatisation et
                l’hygiène alimentaire.
              </p>
              <blockquote className="border-l-[3px] border-vert pl-6 py-1">
                <p className="font-serif italic text-lg text-vert-dark">
                  « Une procédure que l’on n’applique pas ne protège personne. »
                </p>
              </blockquote>
            </div>
            <div className="rounded-lg overflow-hidden shadow-[0_2px_20px_rgba(0,0,0,0.08)]">
              <img
                src="/images/francois-schoonheere.webp"
                alt="François Schoonheere, formateur professionnel"
                data-testid="portrait-francois"
                className="w-full h-[380px] lg:h-[480px] object-cover object-top"
                loading="lazy"
                width="800"
                height="1422"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="max-w-3xl mx-auto px-6">
          <h2 className="font-serif text-3xl text-marine mb-12 text-center">Le parcours, 1987 → 2026</h2>
          <div className="relative border-l-2 border-vert/40 ml-3 space-y-10">
            {TIMELINE.map((t) => (
              <div key={t.periode} data-testid="timeline-item" className="relative pl-8">
                <span className="absolute -left-[9px] top-1.5 w-4 h-4 rounded-full bg-vert border-4 border-white shadow" />
                <p className="font-sans text-xs font-semibold uppercase tracking-[2px] text-vert-dark mb-1">
                  {t.periode}
                </p>
                <h3 className="font-serif text-xl text-marine mb-1">{t.titre}</h3>
                <p className="font-sans text-sm text-gris-texte leading-relaxed">{t.texte}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-sable py-16">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-serif text-3xl text-marine mb-4">Travailler ensemble</h2>
          <p className="font-sans text-base text-marine/80 mb-8">
            Un besoin de formation, d’accompagnement ou d’audit ? Parlons-en.
          </p>
          <Btn to="/contact" testid="qsj-cta-contact" variant="primary">
            Me contacter
          </Btn>
        </div>
      </section>

      <DevisCta />
    </div>
  );
}
